/* eslint-disable import/no-duplicates */
import React from 'react';

import { appointmentDateTimeDisplay, appointmentServiceType } from '../helpers';
import {
  Actions,
  CollapseButton,
  Container,
  Header,
  HeaderSubTitle,
  HeaderTitle,
} from './styles';

interface Props {
  agendamento: fhir4.Appointment;
}

const BoxAgendamento: React.FC<Props> = ({ agendamento }) => {
  const subtitleRef = React.createRef<HTMLHeadingElement>();

  const [isOpenedDetails, setIsOpenedDetails] = React.useState(false);
  const [showCollapse, setShowCollape] = React.useState(false);

  const Title = React.useMemo(() => {
    const service = appointmentServiceType(agendamento);

    return (
      <>
        <strong>{service}</strong> | {appointmentDateTimeDisplay(agendamento)}
      </>
    );
  }, [agendamento]);

  const description = React.useMemo(() => {
    return agendamento.description;
  }, [agendamento]);

  const hasDescription = React.useMemo(() => !!description, [description]);

  const toggleDetails = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();

      if (hasDescription) {
        setIsOpenedDetails(prev => !prev);
      }
    },
    [hasDescription],
  );

  React.useEffect(() => {
    if (subtitleRef?.current) {
      setShowCollape(
        subtitleRef?.current?.scrollHeight > subtitleRef?.current?.clientHeight,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container detailsOpen={isOpenedDetails}>
      <Header>
        <HeaderTitle highlight={isOpenedDetails}>{Title}</HeaderTitle>
        <Actions>
          {showCollapse && (
            <CollapseButton
              collapsed={isOpenedDetails}
              onClick={toggleDetails}
            />
          )}
        </Actions>
      </Header>

      <HeaderSubTitle ref={subtitleRef}>{description}</HeaderSubTitle>
    </Container>
  );
};

export default BoxAgendamento;
